import { CompanyTaskPage } from './CompanyTask';
import { createHandle } from './handle';
import { createLoader } from './loader';

export default {
  Component: CompanyTaskPage,
  createHandle,
  createLoader
};
